import React from 'react';
import { Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import StepSublistEditor from '../components/StepSublistEditor';
import { StepSection } from '../v2/constants';
import { IChatTaskFeatureConfig } from '@scale/shared/types/config';

type BeforeStepsProps = {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
  chatTaskFeatureConfig?: IChatTaskFeatureConfig;
  displayMLQualitySettings?: boolean;
  setForHeader?: boolean;
  navProps?: {
    currentSection?: StepSection;
    currentFieldId?: string;
  };
  setNavProps?: React.Dispatch<
    React.SetStateAction<{
      currentSection?: StepSection;
      currentFieldId?: string;
    }>
  >;
};

const BeforeSteps = ({
  value,
  onSubmit,
  displayMLQualitySettings,
  setForHeader,
  navProps,
  setNavProps,
  chatTaskFeatureConfig,
}: BeforeStepsProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Before Steps</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Before Steps are run at the start of a chat session. They are usually used to show taskers
        instructions or collect information before the conversation begins. The Prompt Input step is
        a required step and the input will be used as the prompt for the first chat turn.
      </Typography.Paragraph2>
      <StepSublistEditor
        value={value}
        onSubmit={onSubmit}
        property="before"
        displayMLQualitySettings={displayMLQualitySettings}
        setForHeader={setForHeader}
        navProps={navProps}
        setNavProps={setNavProps}
        chatTaskFeatureConfig={chatTaskFeatureConfig}
      />
    </div>
  );
};

export default BeforeSteps;
